exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".org-outline-container {\n  display: flex;\n  flex: 0 0 500px;\n  flex-direction: column;\n  margin-right: 2px; }\n  .org-outline-container .tree-container {\n    max-height: 100%;\n    border-radius: 3px;\n    background-color: transparent;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0; }\n    .org-outline-container .tree-container .tree-list {\n      max-height: 100%;\n      overflow: hidden;\n      padding: 0.4em;\n      padding-bottom: 1px;\n      padding-right: 6px; }\n", ""]);

// exports
